/**
 * fr-FR display formatters. Date inputs are ISO-8601 UTC strings from the API;
 * they are rendered in UTC so the displayed calendar day is stable regardless
 * of the viewer's timezone.
 */
const PLACEHOLDER = '—'

const dateFmt = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: 'UTC',
})

const dateTimeFmt = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'UTC',
})

const currencyFmt = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
})

const numberFmt = new Intl.NumberFormat('fr-FR')

function parse(iso: string | null | undefined): Date | null {
  if (!iso) return null
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatDate(iso: string | null | undefined): string {
  const date = parse(iso)
  return date ? dateFmt.format(date) : PLACEHOLDER
}

export function formatDateTime(iso: string | null | undefined): string {
  const date = parse(iso)
  return date ? dateTimeFmt.format(date) : PLACEHOLDER
}

export function formatCents(cents: number | null | undefined): string {
  if (cents === null || cents === undefined || Number.isNaN(cents)) return PLACEHOLDER
  return currencyFmt.format(cents / 100)
}

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return PLACEHOLDER
  return numberFmt.format(value)
}
